export const LIST_PAGE_SIZES = [5, 10, 50, 100];
export const LIST_PAGE_SIZE_DEFAULT = 5;

export const MODAL_DIALOG_LIST_PAGE_SIZES = [5, 10];
export const MODAL_DIALOG_LIST_PAGE_SIZE_DEFAULT = 5;
